// VER-218: session-based auth guard for Console routes.
// Session-native replacement for the legacy localStorage PrivateRoute. While the
// session is bootstrapping (re-minting the access token from the refresh cookie)
// we render nothing, so there's no flash of the login page before it resolves.
import { Navigate } from "react-router-dom";
import { Spin } from "antd";
import { useSession } from "./useSession";

// Centered full-viewport spinner while the session bootstraps (re-minting the access
// token from the refresh cookie), so there's no flash of the login page.
function BootstrapSpinner() {
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center" }}>
      <Spin size="large" />
    </div>
  );
}

export default function RequireAuth({ children, redirectTo = "/console/login" }) {
  const { status } = useSession();

  if (status === "loading") return <BootstrapSpinner />;
  if (status !== "authenticated") return <Navigate to={redirectTo} replace />;
  return children;
}
